export var uniqueArray = function (values) {
    return Array.from(new Set(values));
};
